import { render, staticRenderFns } from "./StaticSideNav.vue?vue&type=template&id=18d3eff6"
import script from "./StaticSideNav.vue?vue&type=script&lang=js"
export * from "./StaticSideNav.vue?vue&type=script&lang=js"
import style0 from "./StaticSideNav.vue?vue&type=style&index=0&id=18d3eff6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports